import * as React from 'react';
const CustomDnbMajor = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <g data-name="Layer 2">
      <g fill="#ff5400" data-name="Layer 1">
        <path d="m7 4 3.14 5.5H3.86z" />
        <path
          fillRule="evenodd"
          d="M7 14a7 7 0 1 0-7-7 7 7 0 0 0 7 7m.43-11.25a.49.49 0 0 0-.86 0l-4 7a.5.5 0 0 0 0 .5.48.48 0 0 0 .43.25h8a.48.48 0 0 0 .43-.25.5.5 0 0 0 0-.5z"
        />
      </g>
    </g>
  </svg>
);
export default CustomDnbMajor;
